import React from 'react'
import { Typography } from '@mui/material'
import { Alert, AlertTitle } from '../../../../../../../components'

const SuspendAlert = props => {
  const testAttr = 'retention-suspend-success-alert'
  return (
    <Alert severity='success' showClose data-test={testAttr}>
      <AlertTitle data-test={`${testAttr}-title`}>
        Suspension successfully scheduled
      </AlertTitle>
      <Typography paragraph data-test={`${testAttr}-message`}>
        Check your e-mail for more details
      </Typography>
    </Alert>
  )
}

export default SuspendAlert
